import classNames from 'classnames';
import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import React from 'react';
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form';

type FormCheckboxGroupFieldProps = {
  title: string;
  fieldName: string;
  options: { label: string; value: string; disabled?: boolean }[];
  rules?:
    | { [key: string]: { value: unknown; message: string } }
    | RegisterOptions;
  variant?: 'full' | 'half';
  onChangeCallback?: (value: string | string[] | undefined) => void;
};

const FormCheckboxGroupField: React.FC<FormCheckboxGroupFieldProps> = ({
  title,
  fieldName,
  options,
  rules,
  variant = 'full',
  onChangeCallback,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const required = typeof rules?.required === 'object';

  return (
    <div
      className={classNames('mt-2', {
        'col-6': variant === 'half',
        'col-12': variant === 'full',
      })}
    >
      <label className="form-label">
        {title}
        {required ? (
          <span aria-label="Required field" className="required">
            *
          </span>
        ) : null}
      </label>
      <Controller
        control={control}
        name={fieldName}
        rules={rules}
        render={({ field: { onChange, onBlur, value } }) => (
          <div>
            {options.map((option) => (
              <div key={option.value} className="mb-1">
                <StylishNewCheckbox
                  label={option.label}
                  checked={value?.includes(option.value) || false}
                  disabled={option.disabled}
                  onChange={(e) => {
                    const newValue = e.target.checked
                      ? [...(value || []), option.value]
                      : (value || []).filter((v: string) => v !== option.value);
                    onChange(newValue);
                    onChangeCallback?.(newValue);
                  }}
                  onBlur={onBlur}
                />
              </div>
            ))}
          </div>
        )}
      />
      {errors[fieldName] ? (
        <div className="form-text form-error">
          {errors[fieldName].message as string}
        </div>
      ) : (
        <div className="form-text-none"></div>
      )}
    </div>
  );
};

export default FormCheckboxGroupField;
